<script>
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getAppVersion() {
      return this.$t('LOGIN.FOOTER.VERSION', {
        version: import.meta.env.VITE_APP_VERSION,
      });
    },
  },
};
</script>

<template>
  <footer
    class="footer-style w-full hidden sm:block sm:h-0 border-t"
    :class="
      isLogin
        ? 'bg-white border-n-background-component'
        : 'bg-white dark:bg-n-background-component border-n-background-component dark:border-n-background-component-contrast'
    "
  >
    <div class="flex flex-row justify-between px-8 h-full gap-8">
      <div class="flex items-center gap-8 h-full">
        <span class="underline" :class="!isLogin && 'dark:text-white'">
          <a
            class="text-xs font-medium"
            href="https://syncentral.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('LOGIN.FOOTER.KNOW_MORE') }}
          </a>
        </span>
        <span class="underline" :class="!isLogin && 'dark:text-white'">
          <a
            class="text-xs font-medium"
            href="https://syncentral.com.br/politica"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('LOGIN.FOOTER.PRIVACY_POLICY') }}
          </a>
        </span>
        <span class="underline" :class="!isLogin && 'dark:text-white'">
          <a
            class="text-xs font-medium"
            href="https://syncentral.com.br/termos"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('LOGIN.FOOTER.TERMS_OF_USE') }}
          </a>
        </span>
      </div>
      <div class="flex items-center h-full">
        <span
          class="text-xs font-medium underline"
          :class="!isLogin && 'dark:text-white'"
        >
          {{ getAppVersion }}
        </span>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
.footer-style {
  height: 45px;
}
</style>
